import { Card, Col, Row } from "react-bootstrap";

const highlights = [
  "Veterans resource navigation for housing, food, healthcare, employment, and benefits.",
  "Direct bridge assistance and emergency support during difficult seasons.",
  "Community outreach and follow-through to reduce barriers and improve outcomes.",
  "Partnership-driven support through trusted agencies, food banks, and local providers.",
  "Volunteer coordination and community service opportunities.",
  "Mission-focused advocacy grounded in service, dignity, and accountability.",
];


function HomePage() {
  return (
    <section>
      <section className="mb-4">
        <Card className="resource-card crisis-static-card text-light border-danger-subtle mb-3">
          <Card.Body className="d-flex flex-column flex-md-row align-items-md-center justify-content-between gap-2">
            <div className="text-start">
              <div className="fw-bold">If this is an immediate crisis</div>
              <div className="small text-muted-soft">Call or text 988, then press 1 for the Veterans Crisis Line.</div>
            </div>
            <a className="btn btn-danger" href="tel:988">Call 988 Now</a>
          </Card.Body>
        </Card>

        <Row className="g-4 align-items-stretch">
          <Col className="d-flex flex-column">
            <Card className="glass-card home-highlights-card home-mission-glass-card text-light mb-3 flex-shrink-0">
              <Card.Body>
                <h1 className="section-title mb-3">Fremont Veterans Group</h1>
                <p className="text-light mb-0">
                  <span className="mission-lead fw-bold">Our mission is born from gratitude and guided by compassion.</span> We stand beside the men and women who once stood for us, connecting veterans to practical resources, offering steady guidance through difficult seasons, and working with
                  community partners to reduce food insecurity.
                </p>
              </Card.Body>
            </Card>

            <Card className="glass-card home-highlights-card home-services-card text-light flex-fill">
              <Card.Body className="d-flex flex-column h-100">
                <h2 className="h4 mb-3">What Fremont Veterans Group Does</h2>
                <ul className="text-muted-soft mb-0 home-highlights-list">
                  {highlights.map((item) => (
                    <li key={item} className="mb-2">{item}</li>
                  ))}
                </ul>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </section>
    </section>
  );
}

export default HomePage;
